// extracted by mini-css-extract-plugin
module.exports = {"container":"X689D01S","dateSpan":"lP1ui_G8","styledPriceDisplay":"cIEV4hRV"};